import requestFunctions from "../../functions/requestFunctions";


export const state = {
  SERVERS_ITEM: {},
  SERVERS_LIST: [],
  SERVERS_TABLE_DATA: [],
  SERVERS_LIST_DATA: [],
  SERVERS_TOTAL_ROWS: 0
}

export const getters = {
  GET_SERVERS_ITEM: (state) => {
    return state.SERVERS_ITEM;
  },
  GET_SERVERS_LIST: (state) => {
    return state.SERVERS_LIST;
  },
  GET_SERVERS_TABLE_DATA: (state) => {
    return state.SERVERS_TABLE_DATA;
  },
  GET_SERVERS_LIST_DATA: (state) => {
    return state.SERVERS_LIST_DATA;
  },
  GET_SERVERS_TOTAL_ROWS: (state) => {
    return state.SERVERS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_SERVERS_ITEM(state, item) {
    state.SERVERS_ITEM = item;
  },

  UPDATE_SERVERS_LIST(state, list) {
    
    state.SERVERS_LIST = list.data;

    state.SERVERS_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.SERVERS_TABLE_DATA = [];
    state.SERVERS_LIST_DATA = [];

    list.forEach(el => {

      let status = '';

      if(el.status === 'active'){
        status = 'Активен'
      }
      if(el.status === 'on'){
        status = 'Включён'
      }
      if(el.status === 'stop'){
        status = 'Остановка'
      }
      if(el.status === 'off'){
        status = 'Остановлен'
      }
      if(el.status === 'accident'){
        status = 'Авария'
      }
      if(el.status === 'prevention'){
        status = 'Профилактика'
      }

      state.SERVERS_TABLE_DATA.push({
        'name'   : el.name,
        'status' : status,
        'type'   : el.type,
        'id'     : el.id, 
        'ip'     : el.ip,
        'uuid'   : el.uuid,
        'cloud_id'   : el.cloud_id,
        'priority'   : el.priority,
        'on_default' : el.on_default,        
        'operations' : el.operations,
        'updated_at' : el.updated_at,
        'created_at' : el.created_at
      });

      state.SERVERS_LIST_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.name,
        ip: el.ip,
      });
    });
  },
}

export const actions = {

  async FETCH_SERVERS_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/servers/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_SERVERS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_SERVERS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.client.za-bota.com/v1/servers';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_SERVERS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_SERVERS_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/servers';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_SERVERS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/servers/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_SERVERS_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/servers/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}